import LegalPageLayout from "../components/LegalPageLayout";

const summaryItems = [
    "Using Genesis Recovery AI means you agree to follow these terms.",
    "The platform provides support tools and information, not medical treatment.",
    "Paid subscriptions renew automatically until you cancel.",
    "You are responsible for lawful, respectful use of the service.",
    "We may update or suspend features when needed to protect users and the platform.",
];

const sections = [
    {
        heading: "Acceptance of Terms",
        paragraphs: [
            "By accessing or using Genesis Recovery AI, you agree to be bound by these Terms of Service and any applicable laws and regulations. If you do not agree, you should not use the platform.",
        ],
    },
    {
        heading: "Eligibility and Use",
        paragraphs: [
            "You may use Genesis Recovery AI only if you are legally permitted to do so under applicable law. You are responsible for ensuring your use complies with local laws and requirements.",
        ],
        bullets: [
            "Provide accurate information when creating or using an account",
            "Use the platform only for lawful purposes",
            "Maintain the confidentiality of any account credentials",
        ],
    },
    {
        heading: "No Medical Advice",
        paragraphs: [
            "Genesis Recovery AI is a support and informational platform. It does not provide medical, psychiatric, legal, or emergency services, and it is not a substitute for licensed professional care.",
            "If you are in crisis or facing an emergency, seek immediate help from appropriate local emergency or professional services.",
        ],
    },
    {
        heading: "User Conduct",
        paragraphs: [
            "You agree not to misuse the platform, interfere with service availability, attempt unauthorized access, or upload content that is unlawful, harmful, abusive, infringing, or otherwise inappropriate.",
        ],
        bullets: [
            "Do not attempt to reverse engineer or exploit the service",
            "Do not upload malware, spam, or harmful code",
            "Do not impersonate another person or misrepresent your identity",
            "Do not use the platform in a way that harms other users or our systems",
        ],
    },
    {
        heading: "Accounts and Access",
        paragraphs: [
            "We may suspend, limit, or terminate access if we believe there has been misuse, a security concern, a legal issue, or a violation of these terms.",
            "We reserve the right to modify, update, or discontinue features at any time.",
        ],
    },
    {
        heading: "Intellectual Property",
        paragraphs: [
            "All content, branding, software, design elements, and related materials associated with Genesis Recovery AI are owned by us or our licensors and are protected by applicable intellectual property laws.",
        ],
    },
    {
        heading: "Third-Party Services",
        paragraphs: [
            "The platform may include links or integrations with third-party services. We are not responsible for the content, policies, or practices of those third parties, and your interactions with them are governed by their own terms.",
        ],
    },
    {
        heading: "Subscriptions and Auto-Renewal (Terms of Use / EULA)",
        paragraphs: [
            "Genesis Recovery AI may offer auto-renewable subscription plans through the Apple App Store (and other app stores where available). Subscription titles, lengths (for example weekly, monthly, or yearly), and prices are shown in the app at the point of purchase and may vary by region.",
            "Payment will be charged to your Apple ID account at confirmation of purchase. The subscription renews automatically unless auto-renew is turned off at least 24 hours before the end of the current period. Your account will be charged for renewal within 24 hours prior to the end of the current period at the then-current subscription price.",
            "You can manage or cancel your subscription in your Apple ID Account Settings after purchase. Deleting the app does not cancel your subscription. Any unused portion of a free trial period, if offered, is forfeited when you purchase a subscription.",
            "This Terms of Service page is our Terms of Use (EULA) for the Genesis Recovery AI app and website. Our Privacy Policy explains how we handle personal information and is available at /privacy-policy.",
        ],
        bullets: [
            "Subscription name, length, and price are displayed in the app before you buy",
            "Subscriptions auto-renew until cancelled in Apple ID settings",
            "Manage subscriptions: Settings → Apple ID → Subscriptions",
            "Privacy Policy: /privacy-policy",
        ],
    },
    {
        heading: "Disclaimer of Warranties",
        paragraphs: [
            "Genesis Recovery AI is provided on an \"as is\" and \"as available\" basis without warranties of any kind, whether express or implied, except where prohibited by law.",
            "We do not guarantee uninterrupted availability, error-free performance, or that the platform will meet every individual need or expectation.",
        ],
    },
    {
        heading: "Limitation of Liability",
        paragraphs: [
            "To the maximum extent permitted by law, Genesis Recovery AI and its affiliates, officers, employees, and partners will not be liable for indirect, incidental, special, consequential, or punitive damages arising from or related to your use of the platform.",
        ],
    },
    {
        heading: "Changes to These Terms",
        paragraphs: [
            "We may update these Terms of Service from time to time. Continued use of the platform after updates take effect means you accept the revised terms.",
        ],
    },
    {
        heading: "Governing Law",
        paragraphs: [
            "These terms are governed by applicable laws and will be interpreted in accordance with those laws, without regard to conflict of law principles where not required.",
        ],
    },
    {
        heading: "Contact Us",
        paragraphs: [
            "If you have questions about these Terms of Service, please contact Genesis Recovery AI using the contact information below.",
        ],
    },
];

export default function TermsOfServicePage() {
    return (
        <LegalPageLayout
            title="Terms of Service"
            subtitle="Terms of Use (EULA) — the rules and expectations that apply when you access or use Genesis Recovery AI."
            summaryTitle="Before you use Genesis Recovery AI"
            summaryItems={summaryItems}
            note="These terms are provided as a structured website page matching your design direction. If you need legally reviewed final copy, you should still replace this with your approved legal text."
            sections={sections}
        />
    );
}
